import React from 'react';
import withRouter from '../../Components/withRouter';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
    { code: 'pl', label: 'PL' },
    { code: 'en', label: 'EN' },
    { code: 'de', label: 'DE' },
];

const ParticlesAuth = ({ children }) => {
    const { i18n } = useTranslation();

    return (
        <React.Fragment>
            <div className="auth-page-wrapper pt-5">
                <div className="auth-one-bg-position auth-one-bg" id="auth-particles">

                    <div className="bg-overlay"></div>

                    <div className="shape">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                        </svg>
                    </div>
                </div>

                <div style={{ position: 'absolute', top: '1rem', right: '1.5rem', zIndex: 10 }}>
                    <div className="d-flex gap-1">
                        {LANGUAGES.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                className={`btn btn-sm ${i18n.language === lang.code ? 'btn-light' : 'btn-ghost-light text-white-50'}`}
                                onClick={() => {
                                    i18n.changeLanguage(lang.code);
                                    localStorage.setItem("I18N_LANGUAGE", lang.code);
                                }}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* pass the children */}
                {children}

                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">&copy; {new Date().getFullYear()} Shadow System B2B</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ParticlesAuth);